import { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoadingSpinner, PageContainer, PageTitle } from "src/components/generic";
import TopNav from "src/components/navigation/TopNav";
import { dynamo } from "src/utils";


const Articles: FunctionComponent = () => {
    const [articles, setArticles] = useState<Record<any, any>[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const fetchArticles = async () => { 
        try {
            const result = await dynamo.fetch.articles();

            setArticles(result?.articles?.Items);
        } catch (error: any) {
            setError(error?.message || 'Failed to Fetch Articles');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!Array.isArray(articles)) fetchArticles();
    }, []);

    if(loading) return <LoadingSpinner />

    return (
        <PageContainer>
            <TopNav />
            <PageTitle title="ClientVitals' Articles" />

            <div className="w-[75%] mx-auto">
            {
                articles?.map((article: any) => (
                    <Link to={`/resources/articles/${article.id}`}>
                        <div className="mb-4 group bg-white border border-gray-200 rounded-xl p-6 shadow-md transform transition duration-300 hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 cursor-pointer">
                            <p className="text-lg font-semibold text-gray-800 group-hover:text-blue-700 transition-colors duration-300">
                                {article.title}
                            </p>
                            <p className="text-sm text-gray-500 group-hover:text-blue-600 transition-colors duration-300 mt-1">
                                Author: {article.author}
                            </p>
                            <div className="mt-3 h-1 w-32 bg-blue-500 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-200 rounded"></div>
                        </div>
                    </Link>
                ))
                }
            </div>
        </PageContainer>
    )
}

export default Articles;